import { PreviewEmailTypeEnum } from '../enum/previewEmailType.enum';

export const PreviewEmailType = {
	[PreviewEmailTypeEnum.DEFAULT]: 'Plantilla patrón',
	[PreviewEmailTypeEnum.CUSTOM]: 'Plantilla personalizada',
};
